import React, { useContext } from "react";
import { BackButton } from "./BackButton";
import { BqnSelector } from "./BqnSelector";
import BqnContext from "common/BqnContext";
import styled from "styled-components";

const HeaderLayout = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: space-between;
  padding-bottom: 20px !important;
  gap: 10px;
  .back-button {
    @media screen and (min-width: 550px) {
    }
    justify-self: center;
    flex-shrink: 0;
    flex-grow: 0;
    &.margin-r-15 {
      margin-right: 0 !important;
    }
  }
`;

const HeaderMainLine = styled.div`
  gap: 5px;
  flex-basis: content;
  flex-grow: 2;
  flex-shrink: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  & .title {
    text-transform: uppercase;
  }
  h2 .title {
    margin: 4px 0 7px;
  }
  position: relative;
`;

const SubTitleContainer = styled.div`
  order: 2;
  align-self: flex-start;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ContextWrapper = styled.span`
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  align-items: flex-start;
  justify-content: flex-end;
  display: flex;
  flex-flow: row wrap;
  gap: 0.5em;

  .header-dropdown {
    position: relative !important;
    top: unset !important;
    right: unset !important;
    margin: 0;
    padding: 0;
    align-items: flex-end;
    justify-content: center;
  }

  .context-menu {
    list-style: none;
    display: flex;
    flex-flow: row wrap;
    gap: 0.25em;
    i {
      color: #949494;
      font-size: 24px;
      transition: all 0.5s;

      :hover {
        color: #000;
      }
    }
  }
`

export function Header({
  title,
  contextMenu,
  subtitle,
  backButton = false,
  big,
  bqnSelector = true,
  titleClassName = "",
  returnUrl,
}) {
  const {
    clusterStatus: { mode },
  } = useContext(BqnContext);
  return (
    <HeaderLayout className={`header block-header ${mode}`}>
      {backButton && (<BackButton returnUrl={returnUrl} className="back-button" />)}
      <HeaderMainLine>
        <TitleContainer>
          <h2 className={`title ${titleClassName}`}>
            {big ? <big className="title">{title}</big> : title}
          </h2>
        </TitleContainer>
        {subtitle ? <SubTitleContainer className="subtitle" ><small>{subtitle}</small></SubTitleContainer>: null}
      </HeaderMainLine>
      <ContextWrapper>
        {bqnSelector ? <BqnSelector /> : null}
        {contextMenu ? contextMenu : null}
      </ContextWrapper>
    </HeaderLayout>)
}

export default Header;
